module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "aio-input",
    attrs: {
      "id": "blood-glucose-input"
    }
  }, [_c('mu-card-actions', {
    staticClass: "aio-input-header pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "14px",
      "height": "16px",
      "viewBox": "26 191 11 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M36.3873266,202.013826 C36.3873266,201.047215 36.0280503,199.003253 34.5350319,197.082478 C33.2459103,195.424041 31.1433712,191 31.1433712,191 C31.1433712,191 29.1414164,195.424041 27.8522947,197.082448 C26.3592763,199.003223 26,201.047186 26,202.013826 C26,204.564452 28.2936491,206.63741 31.1433712,206.685209 L31.1433712,206.686322 C31.1601681,206.686322 31.1768993,206.685883 31.1936633,206.685766 C31.2104602,206.685912 31.2271914,206.686322 31.2439883,206.686322 L31.2439883,206.685209 C34.0936775,206.63741 36.3873266,204.564452 36.3873266,202.013826 L36.3873266,202.013826 Z",
      "id": "Shape",
      "stroke": "none",
      "fill": "#E74C3C",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.isOpenInput ? _vm.$t('message.closeText') : _vm.$t('message.addEntryText')),
      expression: "isOpenInput ? $t('message.closeText') : $t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'add_circle'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon blueIcon",
    attrs: {
      "icon": 'remove_circle_outline'
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "novalidate": ""
    }
  }, [_c('mu-card-text', [_c('mu-row', [(_vm.$store.state.user.settings.blood_glucose.measure === 'mgdl') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "540",
      "data-vv-rules": 'required|min_value:0|max_value:540',
      "data-vv-as": "mg/dL",
      "data-vv-name": "mgdl",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mgdl'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mgdl),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mgdl", _vm._n($$v))
      },
      expression: "model.blood_glucose_mgdl"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure === 'mmoll') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "30",
      "data-vv-as": "mmol/L",
      "data-vv-rules": 'required|min_value:0|max_value:30',
      "data-vv-name": "mmoll",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('mmoll'),
      "label": _vm.$t('message.labelBloodSugar'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.blood_glucose.unit
    },
    model: {
      value: (_vm.model.blood_glucose_mmoll),
      callback: function($$v) {
        _vm.$set(_vm.model, "blood_glucose_mmoll", _vm._n($$v))
      },
      expression: "model.blood_glucose_mmoll"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "25",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": _vm.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_percent'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_percent),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_percent", _vm._n($$v))
      },
      expression: "model.hba1c_percent"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.blood_glucose.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "300",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit,
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "label": _vm.$t('message.labelHba1cOptional'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true,
      "helpText": _vm.$store.state.user.settings.hba1c.unit
    },
    model: {
      value: (_vm.model.hba1c_mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_mmol_mol", _vm._n($$v))
      },
      expression: "model.hba1c_mmol_mol"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-select-field', {
    attrs: {
      "multiple": "",
      "separator": ", ",
      "label": _vm.$t('message.labelTagYourReading'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": true,
      "maxHeight": 300,
      "scroller": _vm.scroller
    },
    model: {
      value: (_vm.model.tags),
      callback: function($$v) {
        _vm.$set(_vm.model, "tags", $$v)
      },
      expression: "model.tags"
    }
  }, _vm._l((_vm.readingTags), function(tag, index) {
    return _c('mu-menu-item', {
      key: 'reading-tag-' + index,
      attrs: {
        "value": tag,
        "title": _vm.$t(_vm.localizeTag(tag.tag))
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b786eb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddProgress/aio-components/BloodGlucose/BloodGlucose.vue
// module id = 3657
// module chunks = 1